import script from "./order.vue?vue&type=script&setup=true&lang=js"
export * from "./order.vue?vue&type=script&setup=true&lang=js"

import "./order.vue?vue&type=style&index=0&id=5c78e62a&scoped=true&lang=css"

import exportComponent from "/Users/a1234/Documents/vue/vue3/demo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5c78e62a"]])

export default __exports__